import { HttpErrorResponse } from '@angular/common/http';
import { AnalyticsTimeslice } from '@legacy/analytics/interfaces/analytics-timeslice';
import { createReducer, on } from '@ngrx/store';
import * as actions from './analytics.actions';
import { ShipmentBasis } from '@legacy/analytics/interfaces/basis';
import { Product } from '@legacy/analytics/interfaces/product';
import { Station } from '@legacy/analytics/interfaces/station';

export interface AnalyticsState {
  data: AnalyticsTimeslice[];
  isPending: boolean;
  error: HttpErrorResponse | null;
  productGroup: Product;
  destination: Station;
  shipments: ShipmentBasis[];
  scale: string;
}

export const analyticsInitialState: AnalyticsState = {
  data: [],
  isPending: false,
  error: null,
  productGroup: { code: 'REG', name: 'Бензин Регуляр-92' },
  // @ts-ignore
  destination: null,
  shipments: [
    { code: 'KOB', name: 'Комбинатская, Западно-Сибирская ЖД' },
    { code: 'LUL', name: 'Волгоград - группа станций' },
    { code: 'NOV', name: 'Новая Еловка, Красноярская ЖД' },
  ],
  scale: '1m',
};

export const analyticsReducer = createReducer(
  analyticsInitialState,

  on(actions.loadAnalyticsData, (state) => {
    return {
      ...state,
      isPending: true,
    };
  }),

  on(actions.loadAnalyticsDataSuccess, (state, action) => {
    return {
      ...state,
      data: action.data,
      isPending: false,
      error: null,
    };
  }),

  on(actions.loadAnalyticsDataFailure, (state, action) => {
    return {
      ...state,
      data: [],
      isPending: false,
      error: action.error,
    };
  }),

  on(actions.updateAnalyticsDataSuccess, (state, action) => {
    return {
      ...state,
      data: action.data,
    };
  }),

  on(actions.setAnalyticsProductGroup, (state, action) => {
    return {
      ...state,
      isPending: true,
      productGroup: action.productGroup,
    };
  }),

  on(actions.setAnalyticsDestination, (state, action) => {
    return {
      ...state,
      isPending: true,
      destination: action.destination,
    };
  }),

  on(actions.setAnalyticsShipments, (state, action) => {
    return {
      ...state,
      isPending: true,
      shipments: action.shipments,
    };
  }),

  on(actions.setAnalyticsScale, (state, action) => {
    return {
      ...state,
      isPending: true,
      scale: action.scale,
    };
  }),
);
